import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export class WhReciptsListItem extends SearchModelBase {
    refNo: string = '';
    branch: string = '';
    receivedDate: string | null = null;
    fromReceivedDate: string | null = null;
    toReceivedDate: string | null = null;
    truckBLNo: string = '';
    amount: number|null = null;
    toAmount: number|null = null;
    fromAmount: number|null = null;
    hazGoods: boolean|null = null;
    poNo: string = '';
    blNo: string = '';
    maker: string = '';
    sName: string = '';
    sName1: string = '';
    commodity: string = '';
    postDate: string | null = null;
    id: number = 0;
    shipper: number = 0;
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    u1ID: string = '';
    u2ID: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    receivedBy: string = '';
    shipped: boolean|null = null;
    pkgs: number|null = null;
    fromPkgs: number|null = null;
    toPkgs: number|null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: '', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Freight Receipt #', width: 100, dataIndex: 'refNo', defaultColumnFocus : true}),
        XCol.Create({ col: 2, text: 'BR', width: 40, dataIndex: 'branch'}),
        XCol.Create({ col: 3, text: 'Received Date', width: 75, dataIndex: 'receivedDate', type: XCol.XCellType.Date}),
        XCol.Create({ col: 4, text: 'Received by', width: 75, dataIndex: 'receivedBy'}),
        XCol.Create({ col: 5, text: 'Truck B/L #', width: 100, dataIndex: 'truckBLNo'}),
        XCol.Create({ col: 6, text: 'P.O #', width: 100, dataIndex: 'poNo'}),
        XCol.Create({ col: 7, text: 'B/L #', width: 100, dataIndex: 'blNo'}),
        XCol.Create({ col: 8, text: 'PKG(s)', width: 60, dataIndex: 'pkgs', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0', noNullOrEmptySearch: true }),
        XCol.Create({ col: 9, text: 'Shipped', width: 60, dataIndex: 'shipped', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 10, text: 'Shipper', width: 120, dataIndex: 'sName'}),
        XCol.Create({ col: 11, text: 'Maker', width: 120, dataIndex: 'maker'}),
        XCol.Create({ col: 12, text: 'Consignee', width: 120, dataIndex: 'sName1'}),
        XCol.Create({ col: 13, text: 'Commodity', width: 150, dataIndex: 'commodity'}),
        XCol.Create({ col: 14, text: 'Amount', width: 100, dataIndex: 'amount', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true}),
        XCol.Create({ col: 15, text: 'Hazardous', width: 60, dataIndex: 'hazGoods', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 16, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 17, text: 'Create by', width: 80, dataIndex: 'u1ID'}),
        XCol.Create({ col: 18, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime}),
        XCol.Create({ col: 19, text: 'Update by', width: 80, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(useBranch: boolean): XCol.XExportColumn[] {
        let returnCloumns = _.cloneDeep(this.ExportCollection);
        if (!useBranch) returnCloumns = returnCloumns.filter(x => x.dataIndex !== 'branch');
        return returnCloumns;
    };
	
    public static OrderBy = { orderBy: WhReciptsListItem.prototype.createdAt, orderByAscending: false };

    public static formatData(data: WhReciptsListItem[]) {
        return data.map((d: WhReciptsListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        receivedDate: {from: 'fromReceivedDate', to: 'toReceivedDate'},
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        amount: {from: 'fromAmount', to: 'toAmount'},
        pkgs: { from: 'fromPkgs', to: 'toPkgs'},
    }
}
